import { TradingPermissionOption } from '@/utils/helpers/rest';

export function formatTradingPermissionOption(option: TradingPermissionOption): string {
  return option.permission === null
    ? 'tradingPermissions.inherit'
    : `tradingPermissions.options.${option.permission}`;
}
